<template>
  <div>
    <div class="texts">
      <div class="emptyText">
        Empty Miles:&nbsp;
      </div>
      <div>
        <div @click="switchOptions" class="milesText">
          {{showText}}
          <div :class="[showOptions ? 'up' : 'down', 'arrow']">
            <img src="./img/arrow.svg" />
          </div>
        </div>
        <div :class="[showOptions ? 'show' : 'hidden', 'options']">
          <div
            v-for="(option, index) in options"
            :key="index"
            @click="emitEvent(index)"
            class="single"
          >
            <button
              :class="{ 'blue-button': selectedButton === index }"
            ></button>
            <div class="option">
              {{ option }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const optionsList = [
  "Driver’s Current Location",
  "Driver’s Last Drop off Location",
  "Enter Manually",
]
export default {
  data() {
    return {
      showOptions: false,
      selectedButton: 1,
      showText: "Based on Driver's Last Drop off Location",
      options: [
        "Based on Driver's Current Location",
        "Based on Driver's Last Drop off Location",
        "Enter Manually",
      ],
    };
  },
  methods: {
    switchOptions() {
      this.showOptions = !this.showOptions;
    },
    emitEvent(idx) {
      this.selectedButton = idx;
      this.$emit("optionClicked", idx);
      this.showText = optionsList[idx]
      this.showOptions = !this.showOptions;
    },
  },
};
</script>

<style lang="scss" scoped>
.texts {
  display: flex;
  flex-direction: row;
  width: auto;
}
.emptyText {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: #7f8596;
}
.milesText {
  display: flex;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: #4066d4;
  cursor: pointer;
  position: relative;
  .arrow {
    margin-left: 4px;
    transform-origin: center;
    transition: transform 0.3s ease-in-out;
  }
  .up {
    transform: rotate(-180deg);
  }
  .down {
    transform: rotate(0);
  }
}
.options {
  position: absolute;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #e1e3e9;
  box-shadow: 0px 4px 10px -2px rgba(16, 24, 40, 0.1),
    0px 0px 4px -2px rgba(16, 24, 40, 0.05);
  border-radius: 4px;
}
.single {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  align-self: stretch;
  cursor: pointer;
}
.option {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #000000;
}
button {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background-color: transparent;
  border: 1px solid #b2b6c0;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
}
.blue-button {
  background: #4066d4;
  border: none;
  border-radius: 8px;
  position: relative;
}
.blue-button::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 3px;
  transform: translate(-50%, -50%);
}

@keyframes slide-down {
  0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}
.show {
  max-height: 300px;
  transition: max-height 0.1s ease-in;
  transform-origin: 50% 0;
  animation: slide-down 0.1s ease-in;
}
.hidden {
  max-height: 0px;
  padding: 0;
  border-width: 0;
  overflow: auto;
  transition: max-height 0.1s ease-out, padding 0s 0.1s ease-out,
    border-width 0s 0.3s ease-out;
}
</style>
